<template>
  <div class="user__social-login">
    <div class="login-info">
      <span>{{ $t("user.loginInfo") }}</span>
    </div>
    <Login :loginTypes="'facebook,google,azure'"></Login>
  </div>
</template>

<script>
import Login from "../user/Login";

export default {
  components: {
    Login
  }
};
</script>
